// import ChessRestClient from "../Api/ChessRestClient";
// import { getLocalStorage } from "../Utils/CommonUtils";
import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

type payloadProps = {
  tournament_id: string;
  user_id: number;
};

export default function useFetchTournamentQuestions() {
  const ChatRestClient = useChatRestClient();
  const mutation = useMutation(async (data: payloadProps) => {
    // TODO: remove the comment
    const response = await ChatRestClient.post(
      '/whatsapp/v1/get_all_questions',
      data,
    );
    return response.data;
  });

  return {
    ...mutation,
    isLoading: mutation.isLoading,
  };
}
